import 'slick-carousel/slick/slick.css';
import { SimpleCarousal } from './variants/simple-carousel';
import { SimpleSlider } from './variants/simple-slider';
import { VerticalSlider } from './variants/vertical-slider';

export { SimpleSlider, SimpleCarousal, VerticalSlider };
